import { classNameParser } from "../../../helpers";
import type { Props } from "../../../types/props";
import { getPriceSizeClass, splitAmount } from "./helpers";
import "./style.css";

type PriceProps = Props<{
  amount: number;
  size: "xsmall" | "small" | "medium" | "large";
  colorClass?: string;
  integer?: boolean;
}>;

export const Price = (props: PriceProps) => {
  const [dollar, cent] = splitAmount(props.amount);
  return (
    <div className={classNameParser(`${getPriceSizeClass(props.size)} ${props.colorClass || ""}`, props.className)} style={props.style}>
      {props.amount < 0 && "-"}
      <sub className={props.colorClass}>$</sub>
      {dollar}
      {!props.integer && (
        <sup>{cent}</sup>
      )}
    </div>
  );
};
